import { API_URL } from './Api';

export const API_URN = '/v1/usuarios';

export function MEUCORREIOS_PESQUISA(id) {
  return {
    url: `${API_URL}${API_URN}/${id}`,
    options: {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}
/*export function MEUCORREIOS_PESQUISA_RESPONSAVEL(id, idResponsavel) {
  return {
    url: `${API_URL}${API_URN}/${id}/consultarResponsavel/${idResponsavel}`,
    options: {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}
*/
export function IDCORREIOS_PESQUISA(id) {
  return {
    url: `${API_URL}${API_URN}/pf/${id}`,
    options: {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}
export function IDCORREIOS_PESQUISA_DEPENDENTE(idCorreios, id) {
  return {
    url: `${API_URL}${API_URN}/pf/dependente/${idCorreios}/${id}`,
    options: {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}
export function ENVIAR_TOKEN(id, body, ipAddress) {
  return {
    url: `${API_URL}${API_URN}/token/${id}`,
    options: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Forwarded-For': ipAddress,
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(body),
    },
  };
}
export function ENVIAR_TOKEN_PARA_EMAIL(id, body, ipAddress) {
  return {
    url: `${API_URL}${API_URN}/tokenParaEmail/${id}`,
    options: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Forwarded-For': ipAddress,
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(body),
    },
  };
}

export function ENVIAR_TOKEN_PARA_TELEFONE(id, body, ipAddress) {
  return {
    url: `${API_URL}${API_URN}/tokenParaTelefone/${id}`,
    options: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Forwarded-For': ipAddress,
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(body),
    },
  };
}
export function CONSULTAR_TOKEN(id) {
  return {
    url: `${API_URL}${API_URN}/${id}/token`,
    options: {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}

export function ATIVAR_IDCORREIOS(id, body) {
  return {
    url: `${API_URL}${API_URN}/${id}/ativacao`,
    options: {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(body),
    },
  };
}
export function ATIVAR_IDCORREIOS_DEPENDENTE(body) {
  return {
    url: `${API_URL}${API_URN}/dependente/ativacao`,
    options: {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(body),
    },
  };
}

export function ALTERAR_MEUCORREIOS(body, ipAddress) {
  return {
    url: `${API_URL}${API_URN}/pf`,
    options: {
      method: 'PATCH',
      headers: {
        'X-Forwarded-For': ipAddress,
        'Content-Type': 'application/json',
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(body),
    },
  };
}
export function ALTERAR_MEUCORREIOS_DEPENDENTE(
  idCorreiosResponsavel,
  body,
  ipAddress,
) {
  return {
    url: `${API_URL}${API_URN}/pf/dependente/${idCorreiosResponsavel}`,
    options: {
      method: 'PATCH',
      headers: {
        'X-Forwarded-For': ipAddress,
        'Content-Type': 'application/json',
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(body),
    },
  };
}
export function ALTERAR_MEUCORREIOS_PJ(body, ipAddress) {
  return {
    url: `${API_URL}${API_URN}/pj`,
    options: {
      method: 'PATCH',
      headers: {
        'X-Forwarded-For': ipAddress,
        'Content-Type': 'application/json',
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(body),
    },
  };
}

export function ALTERAR_EMAIL(
  idCorreiosResp,
  idCorreios,
  token,
  body,
  ipAddress,
) {
  return {
    url: `${API_URL}${API_URN}/${idCorreiosResp}/${idCorreios}/email/${token}`,
    options: {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-Forwarded-For': ipAddress,
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(body),
    },
  };
}

export function ALTERAR_SENHA(idCorreios, body, ipAddress) {
  return {
    url: `${API_URL}${API_URN}/${idCorreios}/senha-redefinicao`,
    options: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Forwarded-For': ipAddress,
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(body),
    },
  };
}

export function ALTERAR_SENHA_DEPENDENTE(
  idCorreiosResp,
  idCorreios,
  body,
  ipAddress,
) {
  return {
    url: `${API_URL}${API_URN}/${idCorreiosResp}/${idCorreios}/senha-redefinicao-dependente`,
    options: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Forwarded-For': ipAddress,
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(body),
    },
  };
}
export function ALTERAR_TELEFONE(
  idCorreiosResp,
  idCorreios,
  token,
  body,
  ipAddress,
) {
  return {
    url: `${API_URL}${API_URN}/${idCorreiosResp}/${idCorreios}/telefone/${token}`,
    options: {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-Forwarded-For': ipAddress,
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(body),
    },
  };
}
export function IDCORREIOS_EXCLUIR(id, body, ipAddress) {
  return {
    url: `${API_URL}${API_URN}/${id}`,
    options: {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'X-Forwarded-For': ipAddress,
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(body),
    },
  };
}
export function IDCORREIOS_EXCLUIR_DEPENDENTE(body, ipAddress) {
  return {
    url: `${API_URL}${API_URN}/dependente`,
    options: {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'X-Forwarded-For': ipAddress,
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(body),
    },
  };
}
export function IDCORREIOS_EXCLUIR_DEPENDENCIAS(id, body, ipAddress) {
  return {
    url: `${API_URL}${API_URN}/dependencias/${id}`,
    options: {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'X-Forwarded-For': ipAddress,
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(body),
    },
  };
}

export function NECESSIDADES_ESPECIAIS(idCorreios) {
  return {
    url: `${API_URL}${API_URN}/pf/${idCorreios}/necessidadesespeciais`,
    options: {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}
export function RFB_PESQUISA(cpf) {
  return {
    url: `${API_URL}${API_URN}/pf/cpf/${cpf}`,
    options: {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}
export function RFB_PESQUISA_PARA_DEPENDENTE(idCorreios, cpf) {
  return {
    url: `${API_URL}${API_URN}/pf/cpfdependente/${idCorreios}/${cpf}`,
    options: {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}
export function RFB_PESQUISA_CNPJ(cnpj) {
  return {
    url: `${API_URL}${API_URN}/pj/cnpj/${cnpj}`,
    options: {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}
export function VALIDAR_E_ENVIAR_TOKEN(body, ipAddress) {
  return {
    url: `${API_URL}${API_URN}/pf/validar`,
    options: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Forwarded-For': ipAddress,
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(body),
    },
  };
}
export function VALIDAR_E_ENVIAR_TOKEN_PJ(body, ipAddress) {
  return {
    url: `${API_URL}${API_URN}/pj/validar`,
    options: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Forwarded-For': ipAddress,
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(body),
    },
  };
}

export function CHECK_RESET_SENHA(idCorreios) {
  return {
    url: `${API_URL}${API_URN}/pj/check-reset-senha/${idCorreios}`,
    options: {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}

export function RECADASTRAMENTO_PF(idCorreios, body, ipAddress) {
  return {
    url: `${API_URL}${API_URN}/pf/${idCorreios}/recadastramento`,
    options: {
      method: 'PATCH',
      headers: {
        'X-Forwarded-For': ipAddress,
        'Content-Type': 'application/json',
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(body),
    },
  };
}

export function VALIDA_CPF_DATA(body, ipAddress) {
  return {
    url: `${API_URL}${API_URN}/pj/validarCPFData`,
    options: {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Forwarded-For": ipAddress,
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
      },
      body: JSON.stringify(body),
    },
  };
}
